import { useMutation } from 'react-query';
import { useCurrentUserCtx } from 'contexts/CurrentUser';
import { AnchorAPI } from 'modules/AnchorAPI';

function useCreateEpisode() {
  const {
    state: { webStationId },
  } = useCurrentUserCtx();
  const { mutate } = useMutation(
    ({ title, description }: { title?: string; description?: string }) => {
      if (!webStationId) {
        Promise.reject(
          new Error('webStationId is required to create a new episode')
        );
      }

      return AnchorAPI.createNewEpisode({
        webStationId: webStationId!,
        title,
        description,
      });
    }
  );
  return { createNewEpisode: mutate };
}

export { useCreateEpisode };
